// src/pages/msp-inventory/components/reports/KpiCard.jsx
import React from "react";

const KpiCard = ({ label, value, sublabel, color = "teal" }) => {
    const colorMap = {
        teal: "text-teal-600", red: "text-red-600", blue: "text-blue-600",
        purple: "text-purple-600", orange: "text-orange-600", green: "text-green-600",
    };
    return (
        <div className="bg-white rounded-2xl shadow-lg p-5">
            <p className="text-xs text-gray-400 font-semibold mb-1">{label}</p>
            <p className={`text-2xl font-bold ${colorMap[color] || colorMap.teal}`}>{value}</p>
            {sublabel && <p className="text-[11px] text-gray-400 mt-1">{sublabel}</p>}
        </div>
    );
};

export default KpiCard;